import './css/styles.scss';

function steglistaInit(): void {}

steglistaInit();
